/**
 * Created by mnaughton on 12/3/2015.
 */

import BaseMessenger from "core/base/Messenger";
import $ from "jquery";
import Page from "core/Page";
import "bootstrap-notify";
var ALL = "all";

var Messenger = BaseMessenger.extend({
  /**
   * Creates an instance of a flash control.
   * @constructor
   */
  constructor: function () {
    BaseMessenger.apply(this, arguments);

    this.offset = {
      y: String(Page.getHeaderHeight()),
    };

    this.placement = {
      from: "top",
      align: "center",
    };

    this.animate = {
      enter: "animated slideInDown",
      exit: "animated fadeOut",
    };

    if (Page.isExtraSmall() || Page.isSmall()) {
      this.offset.y = "5";
      this.animate.enter = "animated slideInUp";
      this.placement.from = "bottom";
    }
  },

  /**
   * Asynchronously removes messages.
   * @param  {Boolean} [all:false] True to expire all messages (including errors), otherwise false.
   */
  reset: function (all) {
    if (all) {
      $.notifyClose(ALL);
    } else {
      $.notifyCloseExcept(BaseMessenger.DANGER);
    }
  },

  /**
   * Publish a message to the user.
   * @param {string} type One of Messenger.TYPES
   * @param {string} message The message to publish.
   * @param {Boolean} [keep:false] True to keep the message around when additional messages are published.
   * @param {Boolean} [append:false] True to append to the existing list of messages, otherwise false.
   * @param {Integer} [delay:1000] The number of milliseconds to persist the message.
   * @protected
   */
  doUpdate: function (type, message, keep, append, delay) {
    delay = delay || 1000;

    if (keep) {
      delay = 0;
    }

    if (!append) {
      this.reset();
    }

    return $.notify(
      {
        // options
        message: message,
      },
      {
        animate: this.animate,
        mouse_over: "pause",
        newest_on_top: true,
        offset: this.offset,
        type: type,
        delay: delay,
        placement: this.placement,
      }
    );
  },
});

export default new Messenger();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/Messenger.js
// module id = 16
// module chunks = 1